module.exports = require("././angular-placeholder-shim.js");


//////////////////
// WEBPACK FOOTER
// angular-placeholder-shim (bower component)
// module id = 37
// module chunks = 0 1